import { Route, BrowserRouter, Switch } from 'react-router-dom';
import React from 'react';
import ReactDOM from 'react-dom';
import thunk from 'redux-thunk';
import App from './app/AppContainer';
import PageNotFound from './route/PageNotFound';
import Auth from './route/Auth';
import Unauthorised from './route/Unauthorised';
import { locale } from 'moment';
import WebSocketProvider from './app/websocket/websocket';

import { composeWithDevTools } from 'redux-devtools-extension';
import { Provider } from 'react-redux';
import { createStore, compose, applyMiddleware } from 'redux';
import MainReducer from './app/data/reducers/main';


// Setup Global location
locale('pt');

export const reduxStore = compose(window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f)(createStore, composeWithDevTools(applyMiddleware(thunk)))(MainReducer)

ReactDOM.render((
    <Provider store={reduxStore}>
        <WebSocketProvider>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/" component={App} />
                    <Route path="/auth" component={Auth} />
                    <Route path="/unauthorised" component={Unauthorised} />
                    <Route path="*" component={PageNotFound} />
                </Switch>
            </BrowserRouter>
        </WebSocketProvider>
    </Provider>
), document.getElementById('app-wrapper'));
